import { render } from "./SegundaVirginidad.vue?vue&type=template&id=6ca443a8"
import script from "./SegundaVirginidad.vue?vue&type=script&lang=js"
export * from "./SegundaVirginidad.vue?vue&type=script&lang=js"
script.render = render

export default script